import pageStyle from "./index.module.less";

export default {
    name: "replayEmail",
    components: {},
    data() {
        return {
            pageStyle,
            form: {
                mail_addr: "",
                mail_content: "",
                left2right: true
            },
            switchIndex: 0
        };
    },
    props: {
        insert: {
            type: String,
            default: ""
        },
        languages: {
            type: Array
        }
    },
    methods: {
        btnClick(id) {
            this.switchIndex = id;
            if (id === 0) {
                this.form.left2right = true;
            } else {
                this.form.left2right = false;
            }
        }
    },
    mounted() {
        this.$on("completeBtn", () => {
            //父组件触发
            this.$emit("complete", this.form);
        });
    },
    watch: {
        form: {
            async handler() {
                const { mail_addr, mail_content } = this.form;
                if (mail_addr.trim() != "" && mail_content != "") {
                    try {
                        let result = await this.$refs.form.validate();
                        if (result) {
                            this.$emit("complete", this.form);
                            return;
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }

                this.$emit("complete", false);
            },
            deep: true
        },
        insert: {
            handler(value) {
                this.form.mail_content += value;
            },
            immediate: true
        }
    }
};
